<template>
  <div>
    <van-nav-bar
      fixed
      placeholder
      left-text="返回"
      left-arrow
      right-text="從POS下載更新餐點"
      :title="title"
      @click-left="cmdBack"
      @click-right="cmdDownloadMenuItem"
      z-index="999"
    >
    </van-nav-bar>
  </div>
</template>
<style scoped>
.navbar {
  position: fixed;
  width: 100%;
  color: yellow;
  top: 0;
  height: 3.6rem;
  line-height: 3.6rem;
  background-color: blue;
}
.h-x4 {
  height: 4rem;
}
</style>

<script>
// @ is an alias to /src

export default {
  components: {},
  props: {
    title: String,
  },
  data() {
    return {};
  },
  methods: {
    cmdDownloadMenuItem() {
      this.gSure("確認從POS取得最新餐點資料").then(async () => {
        await this.apiDownloadMenuItem();
        this.$router.push("/");
      });
    },
    cmdBack() {
      window.location.href = "/";
    },
    cmdFullScreen() {
      var docElm = document.documentElement;
      //W3C
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      }
      //FireFox
      else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      }
      //Chrome等
      else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      }
      //IE11
      else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
    },
  },
};
</script>
